import { store } from "../store/index";
import {
  filterTask,
  removeTask,
  modifyTask,
  getTaskByUuid,
  createTask,
  listAll,
} from "../store/actions/TaskActions";

/**
 * Create Task
 */
export const addTask = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createTask(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Task
 */
export const getTask = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getTaskByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Task
 */
export const updateTask = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyTask(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Task
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterTask(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Task
 */
export const deleteTask = async (uuid) => {
  const result = await store.dispatch(removeTask([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * List all tasks
 */
export const listAllTask = async (filter = null) => {
  const result = await store.dispatch(listAll(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
